import { dateToGMT } from "./generic";

export function prepareLockDate(originalDate: Date, gmt: number) {
  originalDate.setDate(originalDate.getDate() - 1);
  originalDate.setHours(23, 59, 0, 0);
  const lockDate = dateToGMT(originalDate, gmt).toISOString();
  console.log(`prepareLockDate with gmt ${gmt}`, originalDate, lockDate);
  return lockDate;
}
